import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from './SectionHeader';
export function About() {
  const stats = [{
    value: '5+',
    label: 'Continents Active'
  }, {
    value: '500+',
    label: 'Verified Suppliers'
  }, {
    value: '$2B+',
    label: 'Procurement Value'
  }, {
    value: '50+',
    label: 'Institutional Projects'
  }];
  return <section id="about" className="py-24 bg-navy-light relative border-y border-navy-border" data-id="element-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-17">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-18">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} data-id="element-19">
            <SectionHeader eyebrow="Who We Are" title="Independent Procurement Consultancy" data-id="element-20" />

            <div className="space-y-6 text-slate-400 text-lg leading-relaxed" data-id="element-21">
              <p data-id="element-22">
                888 Sourcing Limited operates at the intersection of global
                supply and institutional demand. We specialize in bridging the
                gap between capable manufacturers and complex international
                procurement requirements.
              </p>
              <p data-id="element-23">
                Our expertise lies in navigating the rigorous compliance,
                verification, and bidding processes required by multilateral
                organizations, government bodies, and large-scale infrastructure
                developers.
              </p>
              <p data-id="element-24">
                By maintaining a pre-qualified network of suppliers, we ensure
                that when major tenders are announced, we can rapidly mobilize
                reliable supply chains that meet exact technical and commercial
                specifications.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="grid grid-cols-2 gap-6" data-id="element-25">
            {stats.map((stat, i) => <div key={i} className="bg-navy-card p-8 rounded-sm border border-navy-border hover:border-gold/50 transition-colors" data-id="element-26">
                <div className="text-4xl md:text-5xl font-extrabold text-white mb-2" data-id="element-27">
                  {stat.value}
                </div>
                <div className="text-gold font-medium text-sm uppercase tracking-wider" data-id="element-28">
                  {stat.label}
                </div>
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}